import React from 'react';
import { connect } from 'react-redux';
import Dashboard from '../../components/Dashboard/Dashboard';
import { RootState } from '../../models/RootState';
import './DashboardView.scss';
import LoginRequired from "../../assets/images/common/loginRequired.svg"
import { NavLink } from 'react-router-dom';

type StoreProps = {
  loggedIn: boolean;
  langData:any
};

const DashboardView: React.FC<StoreProps> = (props) => {
  const { loggedIn,langData } = props;
  return (
    <div className={loggedIn? "dashboard-view-ctn": "dashboard-view-ctn not-logged-in"}>
      {!loggedIn ? (
        <div className="not-logged-in-msg">
          <img src={LoginRequired} className="login-required-img" />

          <div className="login-required-heading">{langData?.['login_required']}</div>
          <div className="login-required-text">{langData?.['you_cannot_see_profile_txt']}
            <div>{langData?.['please_login_first']}</div>
          </div>

          <NavLink className='ion-primary-color login-signup-btn' to="/login">{langData?.['login']}</NavLink>
        </div>
      ) : (
        <Dashboard langData={langData} />
      )}
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    loggedIn: state.auth.loggedIn,
    langData:state.common.langData
  };
};

export default connect(mapStateToProps)(DashboardView);
